import React,{ useState,useEffect } from 'react';
import axios from "axios";
import store from '../store';

const chatApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/chat/`
})
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/user/UserAPI/`
})

const MessageBox2 = (sellerID) => {
    useEffect(() => {
        getContacts(store.getState().auth.user.id);
        getMessages(sellerID.sellerID);
        getC(store.getState().auth.user.id,sellerID.sellerID)
      },[]);
    const[message,setMessage]=useState('');
    const[selected,setSelect]=useState(null);
    const[messages,setMessages]=useState([]);
    const[contacts,setContacts]=useState([]);
    const[contacts2,setContacts2]=useState([]);
    //const[flag,setFlag]=useState(false);

    const me = store.getState().auth.user.id;
    const addMessage =async () => {
        var flag = false;
        contacts.map(a=>
            a.Contact_id === sellerID.sellerID ? flag=true:null
        )
        
        let data = new FormData();
        data.append('message',message );
        data.append('sender',me);
        data.append('receiver',selected);
        try {
            await chatApi.post('MessageCreate/',data);
            if(flag === false){
                let data1 = new FormData();
                data1.append('user',store.getState().auth.user.id);
                data1.append('Contact_id',sellerID.sellerID);
                data1.append('last_message',new Date().toJSON())
                await chatApi.post('ContactCreate/',data1);
                let data2 = new FormData();
                data2.append('user',sellerID.sellerID);
                data2.append('Contact_id',store.getState().auth.user.id);
                data2.append('last_message',new Date().toJSON())
                await chatApi.post('ContactCreate/',data2);
                getContacts(store.getState().auth.user.id);
                getC(store.getState().auth.user.id,sellerID.sellerID)
                flag=true;
            }
            
            contacts2.map(async a=>
                {
                if(a.user === store.getState().auth.user.id){
                    let data3 = new FormData();
                    data3.append('last_message',new Date().toJSON());
                    await chatApi.put(`UpdateContact/${a.id}/`,data3);
                }
                else{
                    let data4 = new FormData();
                    data4.append('last_message',new Date().toJSON());
                    data4.append('unread',a.unread+1);
                    await chatApi.put(`UpdateContact/${a.id}/`,data4);
                }
                }
                )

        }
        catch{
            alert("Can't send message!");
        }
        setMessage('');
        getMessages(selected);
    }
    const getMessages = async(user) => {
        let data = await chatApi.get(`MessageRead/${user}/${me}/`).then(({data})=>data);
        setMessages(data);
        setSelect(user) ;
    }
    const getContacts = async(user) => {
        let data = await chatApi.get(`ContactList/${user}/`).then(({data})=>data);
        //const contacts = data.map(({Contact_id}) => Contact_id);
        data.map(a =>
            getReviewGiverName(a,data)
        ) 
    }
    const getC = async(user,seller) => {
        let data = await chatApi.get(`Rcontact2/${user}/${seller}/`).then(({data})=>data);
        setContacts2(data);
        console.log('neww =>', data);
    }
    const getReviewGiverName= async (a,data) => {
        let data1 = await api.get(`/${a.Contact_id}/`).then(({data})=>data);
        a.name=data1[0].first_name + ' ' + data1[0].last_name
        setContacts(data);
    }
    return (
        <div className="modal-dialog modal-lg" >
                <div className="modal-content">
                <div class="modal-header" style={{backgroundColor:'#FFC312'}}>
                    <h5 class="modal-title">Message</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                {localStorage.access ?<>
                <hr style={{padding: '0px',marginTop: '5px', margin:'0px' }}/>
                <div className="modal-body" style={{height:340}}>
                    <div>
                        <div style={{height:'260px',overflowY: 'auto',marginBottom:'5px'}}>
                            {!messages.length ? 
                
                                <p style={{ textAlign:'center'}}>Start A conversation to see Messages</p>
                            : 
                            <div>
                                {messages.map((val) => {
                                    return(
                                        <>
                                        {val.sender === store.getState().auth.user.id ?
                                        <div key={val.id} style={{display:'flex', justifyContent:'flex-end'}}>
                                            <p className='px-3 py-1' style={{display:'inline-block',backgroundColor:'lightblue',borderRadius:7,maxWidth:'70%'}}>{val.message}</p><br/>
                                        </div>
                                        :
                                        <div key={val.id}>
                                            <p className='px-3 py-1' style={{display:'inline-block',backgroundColor:'lightgray',borderRadius:7,maxWidth:'70%'}}>{val.message}</p><br/>
                                        </div>
                                        }
                                        </>
                                    );
                                })}
                            </div>
                            }
                        </div>
                        <div className='row'>
                            <div className='col col-lg-10'><textarea className="form-control" placeholder='type a message' onChange={(e)=>setMessage(e.target.value)} value={message} style={{width:'100%'}} /></div>
                            <button onClick={()=>addMessage()} title='send Message' style={{border: 'none',backgroundColor: 'transparent'}} className='col col-lg-1 ' > <i className='fa fa-play-circle' style={{fontSize:'36px', color:'#FFC312'}}></i> </button>
                        </div>
                    </div>
                </div></>
                :
                <div style={{height:350}}>
                    <h1>Login Please</h1>
                </div>
            }
                </div>
        </div>
    );
};



export default MessageBox2;
